// @core/api/endpoints/billing/delete_billing_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/billing';

/**
 * Delete billing policy
 * Deletes a billing policy. Scope entities will fall through to the next ancestor policy.
 */
export async function DeleteBillingPolicy(
  policy_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/billing-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
